import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const StickyNotesOutlineAppIconIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1835 128q35 0 60 25t25 60v1622q0 35-25 60t-60 25H213q-35 0-60-25t-25-60V213q0-35 25-60t60-25h1622zm-43 1664V256H256v1536h1536zm-768-695q0-30 21-51t52-22h695l-768 768v-695z" />
    </svg>
  ),
  displayName: 'StickyNotesOutlineAppIconIcon',
});

export default StickyNotesOutlineAppIconIcon;
